/* Brand system: customer = ICS Group, platform powered by Fundle */

export function FundleLogo({ height = 16, className = "" }) {
  return (
    <img src="/fundle-logo-white.png" alt="Fundle" style={{ height }} className={className} />
  );
}

export function ICSLogo({ height = 34, light = false, className = "" }) {
  return (
    <img src={light ? "/ics-logo-white.svg" : "/ics-logo-color.svg"} alt="ICS Group"
      style={{ height }} className={className} />
  );
}

/* "Powered by Fundle" — logo reads on dark; on light surfaces we wrap it in a dark chip */
export function PoweredByFundle({ light = false, className = "" }) {
  if (light) {
    return (
      <span className={`inline-flex items-center gap-2 ${className}`}>
        <span className="text-[9px] uppercase tracking-[0.24em] font-bold text-[#A8C3B4]">Powered by</span>
        <FundleLogo height={15} />
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className="text-[9px] uppercase tracking-[0.24em] font-bold text-muted-foreground">Powered by</span>
      <span className="inline-flex items-center bg-[#0A251D] rounded-md px-2 py-1">
        <FundleLogo height={12} />
      </span>
    </span>
  );
}

/* Main lockup: ICS logo + product name */
export function BrandLockup({ light = false, compact = false }) {
  return (
    <div className="flex items-center gap-3">
      <ICSLogo light={light} height={compact ? 30 : 38} />
      <div className={`border-l pl-3 ${light ? "border-white/20" : "border-border"}`}>
        <div className={`font-heading font-black tracking-tight leading-none ${compact ? "text-sm" : "text-base"} ${light ? "text-white" : "text-[#0A251D]"}`}>
          TalentOS <span className="text-[#E05A47]">AI</span>
        </div>
        <PoweredByFundle light={light} className="mt-1" />
      </div>
    </div>
  );
}
